import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';


const config = {
  apiKey: "AIzaSyAUfAWw5UANE6SZYa22SZg3y_Mku4lbCwI",
  authDomain: "lokalpioniere-8fa88.firebaseapp.com",
  databaseURL: "https://lokalpioniere-8fa88.firebaseio.com",
  projectId: "lokalpioniere-8fa88",
  storageBucket: "lokalpioniere-8fa88.appspot.com",
  messagingSenderId: "397113694689",
  appId: "1:397113694689:web:feb0db91879e5aa509daa0",
  measurementId: "G-6VKQR75394"
};

firebase.initializeApp(config);

export default firebase;


